import BaseLayer from "./BaseLayer";
import BoxLayer from "./BoxLayer";
import BoxInside from "../entities/BoxInside";

export default class MiddleLayer extends BaseLayer {
  static instance: MiddleLayer;

  constructor() {
    super();
    if (!MiddleLayer.instance) {
      MiddleLayer.instance = this;
    }

    new BoxInside();
    new BoxLayer();
  }

  static getInstance(): MiddleLayer {
    return MiddleLayer.instance;
  }
}